import React, { useState, useEffect, useCallback } from "react";
import { Container, Form, Button, FloatingLabel, Alert } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import getToken from "../../hooks/getToken";

import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [isLoggedIn, setisLoggedIn] = useState(false);

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);
    setError("");
  };

  const handleLogin = async () => {
    localStorage.clear();

    if (!email || !senha) {
      setError('Preencha o campo E-mail e Senha!');
      return;
    }
    handleSignin(email, senha);
  };

  const handleSignin = async (email, password) => {
    try {
      // Chamar a API local em vez da API externa diretamente
      let { data } = await axios.post('/api/login', { email, password });

      data.date = Date().toString();
      localStorage.setItem('user', JSON.stringify(data));
      localStorage.setItem('token', JSON.stringify(data.token));
      if (!data?.managerId) {
        setError('Nenhuma empresa associada ao usuário.');
        return;
      }

      if (data?.permissionSGU?.restricted?.read !== true || data?.permissionSGU?.restrictedP?.read !== true) {
        setError('Usuário sem permissão para acessar.');
        return;
      }

      await handleCompany(data.managerId);

    } catch (error) {
      setError(error?.response?.data || 'Erro ao efetuar login.');
    }
  };

  const handleCompany = async (id) => {
    if (!id) {
      setError('ID da empresa é inválido.');
      return;
    }
    try {
      let { data } = await axios.post('/api/company/detail', { id, token: getToken() });
      localStorage.setItem('cooperative', JSON.stringify(data));
      await getCooperative(data);
      setisLoggedIn(true);

    } catch (error) {
      setError(error?.response?.data || 'Erro ao obter dados da empresa.');
      localStorage.clear();
    }
  };

  const getCooperative = async (cooperative) => {
    if (cooperative.units.length === 0) {
      return;
    }
    try {
      const { data } = await axios.post('/api/company/get/units', { arrayIds: cooperative?.units, token: getToken() });
      const unitsData = [...data];

      if (cooperative?.equipments?.length) {
        unitsData.push(cooperative);
      }
      unitsData.sort((a, b) => a.name.localeCompare(b.name));
      localStorage.setItem('units', JSON.stringify(unitsData));
      const allEquipments = unitsData.flatMap(item => item.equipments);
      localStorage.setItem('equipment', JSON.stringify(allEquipments));

    } catch (error) {
      console.error(error);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleNavigation = useCallback(() => {
    if (isLoggedIn) {
      navigate("/restrito");
    } else {
      navigate("/");
    }
  }, [navigate, isLoggedIn]);

  useEffect(() => {
    handleNavigation();
  }, [handleNavigation]);

  return (
    <Container
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background: 'radial-gradient(circle at top, #1b2735 0, #090a0f 50%, #020308 100%)',
      }}
      fluid
    >
      <Container
        className="p-4 border-0 rounded-4 shadow-lg"
        style={{
          maxWidth: '420px',
          backgroundColor: 'rgba(15, 23, 42, 0.92)',
          color: '#f8f9fa',
        }}
      >
        <h3 className="text-center mb-1">Login</h3>
        <p className="text-center mb-4" style={{ fontSize: '0.9rem', color: '#adb5bd' }}>
          Informe suas credenciais para continuar.
        </p>
        <Form>
          <FloatingLabel controlId="floatingEmail" label="E-mail" className="mb-3">
            <Form.Control
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={handleEmailChange}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingPassword" label="Senha" className="mb-3">
            <Form.Control
              type="password"
              placeholder="Senha"
              value={senha}
              onKeyPress={handleKeyPress}
              onChange={(e) => {
                setSenha(e.target.value);
                setError('');
              }}
            />
          </FloatingLabel>
          {error && <Alert className="p-2 text-center" variant="danger">{error}</Alert>}
          <Button
            variant="secondary"
            className="w-100"
            onClick={handleLogin}
            size="lg"
            style={{ fontWeight: 600, letterSpacing: '0.5px' }}
          >
            Entrar
          </Button>

        </Form>
      </Container>
    </Container>
  );
};

export default Login;
